var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen w-full flex flex-col bg-scoped-gradient font-primary"},[_c('div',{ref:"contentContainer",staticClass:"flex w-full flex-1 overflow-x-hidden"},[_c('router-view',{staticClass:"w-full"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }